/* Preserve an explicitly selected Xcotton plan in Shopify's native express checkout. */
(function () {
  'use strict';
  if (window.__bestekProductProtectionCheckout) return;
  window.__bestekProductProtectionCheckout = true;

  var panelSelector = '.xcotton-productProtection-detail-warp';
  var selectedSelector = '.xcotton-productProtection-detail-checked[data-id]';
  var ownSelector = 'input[data-bestek-protection-item]';
  var quotes = new Map();
  var signatures = new WeakMap();
  var product;
  var scheduled = false;

  function getProduct() {
    if (product) return product;
    var node = document.querySelector('script#xcotton_pp_variants[type="application/json"]');
    if (!node) return null;
    try {
      var data = JSON.parse(node.textContent);
      if (data.id && Array.isArray(data.variants)) product = data;
    } catch (ignore) {}
    return product || null;
  }

  function context(form) {
    var wallet = form.querySelector('shopify-accelerated-checkout');
    var section = form.closest('.shopify-section');
    var panel = section && section.querySelector(panelSelector);
    if (!wallet || !panel) return null;
    var data = getProduct();
    var idInput = form.querySelector('input[name="id"], select[name="id"]');
    var variant = data && idInput && data.variants.find(function (v) {
      return String(v.id) === String(idInput.value);
    });
    if (!variant) return null;
    var shopify = window.Shopify || {};
    var country = wallet.getAttribute('buyer-country') || shopify.country;
    var currency = wallet.getAttribute('buyer-currency') || (shopify.currency || {}).active;
    var locale = (wallet.getAttribute('buyer-locale') || document.documentElement.lang || 'en').split('-')[0];
    if (!country || !currency) return null;
    var rate = String((shopify.currency || {}).rate || 1);
    return {wallet: wallet, panel: panel, data: data, variant: variant,
      country: country, currency: currency, locale: locale, rate: rate,
      key: [variant.id, country, currency, locale, rate].join(':')};
  }

  function prepare(ctx, retry) {
    var cached = quotes.get(ctx.key);
    if (cached && !(retry && cached.status === 'error')) return cached;
    var state = {status: 'pending', plans: []};
    quotes.set(ctx.key, state);
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, 8000);
    fetch('https://seller.xcottons.com/go/packageOpenApiWeb/plugins/CalcPriceInShopifyProduct?shopDomain=ycjpz8-v1.myshopify.com', {
      method: 'POST', signal: controller.signal,
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({shopDomain: 'ycjpz8-v1.myshopify.com', country: ctx.country,
        locale: ctx.locale, currency: ctx.currency, exRate: ctx.rate,
        productId: ctx.data.id, variantDetail: ctx.variant, ppLocationType: 'normal'})
    }).then(function (response) {
      if (!response.ok) throw new Error('Protection quote unavailable');
      return response.json();
    }).then(function (body) {
      if (Number(body.errCode) !== 0 || !body.data || !Array.isArray(body.data.productProtectionVariantItems)) {
        throw new Error('No matching protection quote');
      }
      state.plans = body.data.productProtectionVariantItems;
      state.status = 'ready';
    }).catch(function () {
      state.status = 'error';
    }).finally(function () {
      clearTimeout(timer);
      schedule();
    });
    return state;
  }

  function clear(form) {
    form.querySelectorAll(ownSelector).forEach(function (input) { input.remove(); });
    signatures.delete(form);
  }

  function message(form, text) {
    var note = form.querySelector('[data-bestek-protection-status]');
    if (!text) {
      if (note) note.remove();
      return;
    }
    if (!note) {
      note = document.createElement('p');
      note.setAttribute('data-bestek-protection-status', '');
      note.setAttribute('role', 'status');
      note.setAttribute('aria-live', 'polite');
      var anchor = form.querySelector('.shopify-payment-button, shopify-accelerated-checkout');
      if (!anchor) return;
      anchor.insertAdjacentElement('afterend', note);
    }
    if (note.textContent !== text) note.textContent = text;
  }

  function sync(form, retry) {
    var ctx = context(form);
    if (!ctx) {
      clear(form);
      message(form, '');
      var section = form.closest('.shopify-section');
      return !(section && section.querySelector(panelSelector + ' ' + selectedSelector));
    }
    // Prefetch only after Xcotton has rendered real choices, never on ineligible pages.
    if (!ctx.panel.querySelector('[data-id]')) { clear(form); return true; }
    var state = prepare(ctx, retry);
    var selected = ctx.panel.querySelector(selectedSelector);
    if (!selected) { clear(form); message(form, ''); return true; }
    var selectedId = selected.getAttribute('data-id');
    var plan = state.status === 'ready' && state.plans.find(function (p) {
      return String(p.variantId) === selectedId;
    });
    var props = plan && plan.properties;
    if (!plan || !/^\d+$/.test(String(plan.variantId)) || !props ||
        String(props.Reference) !== String(ctx.variant.id) || !props['Plan ID'] ||
        (ctx.variant.sku && props._Sku !== ctx.variant.sku) || plan.currency !== ctx.currency) {
      clear(form);
      return false;
    }
    var quantityInput = form.elements.namedItem('quantity');
    var quantity = Number(quantityInput && quantityInput.value || 1);
    if (!Number.isSafeInteger(quantity) || quantity < 1) { clear(form); return false; }
    var signature = JSON.stringify([ctx.key, plan.variantId, quantity, props]);
    if (signatures.get(form) === signature) return true;
    clear(form);
    // Shopify reserves index 0 for the parent product; retain other apps' fields.
    var occupied = new Set();
    form.querySelectorAll('input[name^="shopify-additional-items["]').forEach(function (input) {
      var found = input.name.match(/^shopify-additional-items\[(\d+)\]/);
      if (found) occupied.add(Number(found[1]));
    });
    var index = 1;
    while (occupied.has(index)) index += 1;
    // Portable Wallets expects an AttributeInput array, not a properties object.
    var attributes = Object.keys(props).map(function (key) {
      return {key: key, value: String(props[key])};
    });
    var values = {id: String(plan.variantId), quantity: String(quantity),
      parent_id: String(ctx.variant.id), properties: JSON.stringify(attributes)};
    Object.keys(values).forEach(function (key) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'shopify-additional-items[' + index + '][' + key + ']';
      input.value = values[key];
      input.setAttribute('data-bestek-protection-item', '');
      form.appendChild(input);
    });
    signatures.set(form, signature);
    message(form, '');
    return true;
  }

  function scan() {
    scheduled = false;
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      if (form.querySelector('shopify-accelerated-checkout')) sync(form, false);
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(scan);
  }

  document.addEventListener('xcotton:productProtection:select', schedule);
  document.addEventListener('input', schedule);
  document.addEventListener('change', schedule);
  // Update synchronously before a trusted click reaches Shopify's closed shadow root.
  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element && event.target.closest('shopify-accelerated-checkout, .shopify-payment-button__more-options, #more-payment-options-link');
    if (!target) return;
    var form = target.closest('form');
    if (!form || sync(form, true)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var ctx = context(form);
    var pending = ctx && quotes.get(ctx.key);
    message(form, pending && pending.status === 'pending'
      ? 'Preparing your protection plan. Please try express checkout again in a moment.'
      : 'We could not prepare your protection plan. Please use Add to cart or try express checkout again.');
  }, true);

  function start() {
    var root = document.getElementById('MainContent');
    if (root) new MutationObserver(schedule).observe(root, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'value']
    });
    scan();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
